import { gql } from '@/utilities/commerce'

export default gql`
  fragment product on Product {
    id
    handle
    availableForSale
    title
    description
    vendor
    productType
    isGiftCard
    options {
      id
      name
      values
    }
    priceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    variants(first: 250) {
      edges {
        node {
          id
          title
          image {
            url
          }
          availableForSale
          selectedOptions {
            name
            value
          }
          price {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }
        }
      }
    }
    featuredImage {
      url
      altText
    }
    tags
    updatedAt
  }
`
